import * as types from "../ActionType";

const initState = {
    evaluationDetails: [],
    loadingevaluationDetails: true,
    evaluationDetailsByReader: {},
    loadingevaluationDetailsByReader: true,
}

const EvaluationDetailsReducer = (state = initState, action) => {
    switch (action.type) {
        case types.GET_EVALUATION_DETAILS_TYPE:
            return { ...state, evaluationDetails: action.payload, loadingevaluationDetails: false }
        case types.EMPTY_EVALUATION_DETAILS_TYPE:
            return { ...state, evaluationDetails: action.payload, loadingevaluationDetails: true }
        case types.GET_EVALUATION_DETAILS_BY_READER:
            return { ...state, evaluationDetailsByReader: action.payload, loadingevaluationDetailsByReader: false }
        case types.EMPTY_EVALUATION_DETAILS_BY_READER:
            return { ...state, evaluationDetailsByReader: action.payload, loadingevaluationDetailsByReader: true }
        case types.DELETE_EVALUATION_DETAILS_BY_READER:
            return { ...state, loadingevaluationDetails: true }
        default:
            return state;
    }
};

export default EvaluationDetailsReducer;
